// React Imports
import React, {
  useState,
  useEffect,
  Fragment,
  createRef,
  useCallback,
  useMemo,
  useContext,
  useRef,
} from "react";
import { AuthContext } from "common/services/auth-service";
import { MAGIL_LOCATION } from "common/constants";
import LoginRequestPrompt from "components/prompts/loginRequestPrompt";
import { useHistory, useLocation, useParams } from "react-router";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "./styles.css";
import {
  Diet,
  FilterTypes,
  OrderType,
  RestaurantMenuItem,
  RestaurantMenuRequestType,
} from "common/features/restaurant/restaurantModels";
import {
  NotificationData,
  NotificationPayload,
} from "common/features/notification/notificationModels";
import CustomisationPrompt from "components/prompts/desktopCustomisation";
import DesktopCategoryFilter from "components/desktopCategoryFilter";
import Loadable from "react-loadable";
import { toast } from "react-toastify";

// SVG IMPORTS
import { ReactComponent as HeartIcon } from "common/assets/svg/heart.svg";
import { ReactComponent as SearchIcon } from "common/assets/svg/find.svg";
import { ReactComponent as FilterIcon } from "common/assets/svg/filter.svg";
import { ReactComponent as LeftArrow } from "common/assets/svg/leftArrow.svg";
import { ReactComponent as CrissCross } from "common/assets/svg/inputFieldCrissCross.svg";
import { ReactComponent as Vage1 } from "common/assets/svg/vage1.svg";
import { ReactComponent as Vage2 } from "common/assets/svg/vage2.svg";
import { ReactComponent as Vage3 } from "common/assets/svg/vage3.svg";
import { ReactComponent as Vage4 } from "common/assets/svg/vage4.svg";
import { ReactComponent as Vage5 } from "common/assets/svg/vage5.svg";

import { ReactComponent as PlusIcon } from "common/assets/svg/openSubCategory.svg";
import { ReactComponent as MinusIcon } from "common/assets/svg/closeSubcategory.svg";
import DishCardMobile from "components/dishCard/DishCardMobile";

// Components
import RestaurantHomeFilter from "components/restaurantHomeFilter";
import CheckInFloatingCart from "components/statusCards/checkInFloatingCart";
// Image
import DishCard from "components/dishCard/index";
//import DishFilterDropDown from "components/dishFilterDropDown";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "common/rootReducer";
import {
  getRestaurantDetails,
  getRestaurantMenuDetails,
  clearRestaurantDetailsByLocationId,
  updateCdGuestCount,
  getRestaurantMenuDetailsbyDate,
} from "common/features/restaurant/restaurantAction";

import {
  hideItemMaxCountPrompt,
  saveItemComments,
  saveOrderDetails,
  setEventOrder,
  startEmptyCart,
  storeCartRestaurantDetails,
  updateCartItem,
} from "common/features/cart/cartActions";
import { CartItem } from "common/features/cart/cartModels";
import OfferPrompt from "components/prompts/desktopOfferPrompt";

import { DINE_IN_NOTIFICATION_REQUEST, USER_ID } from "common/constants";
import { ReactComponent as CookingImage } from "common/assets/svg/cooking.svg";
import { ReactComponent as SalonImage } from "common/assets/svg/salonLoading.svg";
import { ReactComponent as SpoonIcon } from "common/assets/svg/spoons-icon.svg";
import { ReactComponent as SearchIconV2 } from "common/assets/svg/search-icon.svg";
import { ReactComponent as ShoppingCartIcon } from "common/assets/svg/shopping-cart-icon.svg";
import { ReactComponent as BakeIcon } from "common/assets/svg/bake-icon.svg";
import CallWaiterImage from "common/assets/images/call-waiter.png";
import CallWaiterV2Image from "common/assets/images/waiter-icon.png";
import WaterImage from "common/assets/images/water-icon.png";
import CloseMenuIcon from "common/assets/images/close-menu-icon.png";
import SaltNPepperImage from "common/assets/images/salt-and-pepper-icon.png";
import KetchupImage from "common/assets/images/ketchup-icon.png";
import MenuHeader from "components/MenuHeader";
import CategoryFilter from "components/categoryFilter";
import { useVisibility } from "hooks/useVisibility";
import DropDown from "components/selectionDropDown";
import {
  getMerchantMenuURL,
  getMerchantHomeURL,
  getPlaceOrderURL,
  getDineInPlaceOrderURL,
  getContactlessDineInOrderStatusURL,
  getDineInOrderedPlaceOrderURL,
  getContactlessDineinLandingPage,
} from "common/utils/route-util";
import {
  Category,
  getAvailableCatgorySubCategory,
  getDecimalPlacedPriceString,
  getTwoDecimalValue,
} from "common/utils/menu-helper-utils";
import { useEventLogger } from "hooks/firebase/useEventLogger";
import { RESTAURANT_MENU_VIEW_EVENT_DETAILS } from "firebase/analytics/events";
import PWAInstaller from "components/prompts/installPWA";
import BottomNavigation from "components/BottomNavigation";
import { MenuOptionType } from "common/features/navigation/navigationModels";
import { setMenuOption } from "common/features/navigation/navigationActions";
import { sendNotification } from "common/features/notification/notificationAPI";
import { getRestaurantTableDetails } from "common/features/restaurant/restaurantAPI";
import { getRestaurantTableDetailsRequest } from "common/features/restaurant/restaurantAction";
import { AxiosResponse } from "axios";
import ConfirmationPrompt from "components/prompts/confirmationPrompt";
import {
  clearOfferValidityData,
  clearSelectedOffer,
  requestCheckOffers,
  requestgetOffers,
  requestOfferVality,
  setOfferData,
  successCheckOffers,
} from "common/features/offers/offerActions";
import { storeLocationAfterAuth } from "common/features/auth/AuthActions";
import { usePlaceOrder } from "hooks/usePlaceOrder";
import { offerRequestBody } from "common/features/offers/offferModels";
import CallWaiter from "./CallWaiter";
import PreviewItemPrompt from "components/prompts/desktopItemPreview";
import CustomizeCartMobile from "components/prompts/cartCustomisationMobile";
import CustomizeCartPrevMobile from "components/prompts/cartCustomisationPrevMobile";
import { savePlaceOrderDetails, startEmptyCartOrder, totalsApiLoadingStatusUpadte } from "common/features/order/orderActions";
import { getTotalByCode, manageItemTotalsHelper } from "helper/orderToatals.helper";
import { useOnlinePlaceOrder } from "hooks/useOnlinePlaceOrder";
import CustomizeCart from "components/prompts/cartCustomisation";
import CustomerInfoPopup from "components/CustomerInfoPopup";
import Loading from "components/Loading";
import moment from "moment";
// import { scheduleTask } from "helper/schedulerHelperv1";
import { performTaskAction, updateTaskAction } from "common/features/scheduler/SchedulerActions";
import SpecialMenu from "components/SpecialMenu/SpecialMenu";
import { cleanupScheduler, initializeScheduler } from "helper/schedulerHelperv1";

const SpecialNotePrompt = Loadable({
  loader: () => import("components/prompts/specialNotePrompt"),
  loading: () => null,
});

export interface MenuRouteState {
  loadMenuRequired?: boolean;
  showSearch?: boolean;
  id?: string;
  backFromPlaceOrder?: boolean;
}
export interface RestaurantHomeProps {
  menuType: RestaurantMenuRequestType;
  searchText: string;
  dishData?: any;
}

function RestaurantHome(props: RestaurantHomeProps) {
  const history = useHistory();
  const location = useLocation<any>();

  let { merchantType, merchantSlug, menuType, orderId, tableId,eventDate} =
    useParams<any>();
 // console.log({ eventDate });
    

  useEffect(() => {
    dispatch(setEventOrder(eventDate?true:false,eventDate))
  }, [eventDate])
    

  // Once We impletment Contactless DineIn in Desktop version please remove menuType=="DineIn"
  const isMobile =
    window.innerWidth <= 500 || menuType == ("DineIn" || "checkIn");

  const dispatch = useDispatch();

  const searchRef: any = createRef();
  const menuLocationState = useLocation<MenuRouteState>().state;
  const [selectedMenuType, setSelectedMenuType] = useState("");
  const [openCustomisation, setOpenCustomisation] = useState(false);
  const [openPreviewItemPopup, setOpenPreviewItemPopup] = useState(false);
  const [checked, setChecked] = React.useState(false);
  const [offerPickerOpen, setOfferPickerOpen] = useState(false);

  const [openCustomisationMobile, setOpenCustomisationMobile] = useState(false);
  const [openPreviewItemPopupMobile, setOpenPreviewItemPopupMobile] = useState(false) 

  const [isCustomerInfoPopupOpen, setIsCustomerInfoPopupOpen] = useState(false);


  const WaiterOptionTypes = [
    "Call Waiter",
    "Water - Request",
    "Salt & Pepper - Request",
    "Ketchup - Request",
    "",
  ] as const;

  const userId = localStorage.getItem("USER_ID");

  useEffect(() => {
    dispatch(
      requestgetOffers({
        locationId: restaurantDetails?.id,
        couponId: "",
        customerId: userId,
        orderType: cartMenuType,
        visibleTo: "C",
      } as offerRequestBody)
    );
  }, []);

  //useEffect(() => {
  //   if (!isMobile) {
  //     history.push({
  //       pathname: `/restaurant/${merchantSlug}`,
  //     });
  //   }
  // }, [isMobile]);

  type WaiterOptionType = (typeof WaiterOptionTypes)[number];
  const [currentSelectedWaiterOption, setCurrentSelectedWaiterOption] =
    useState<WaiterOptionType>("");

  const tableDetails = useSelector(
    (state: RootState) => state.restaurant.restaurantTableDetails
  );

  const guestUser = useSelector((state: RootState) => state.auth.guestUser);

  const restaurantMenuTypes = useSelector(
    (state: RootState) => state.restaurant.restaurantSectionTypes
  );
  const refreshMenuDetails = useSelector(
    (state: RootState) => state.restaurant.refreshMenuDetails
  );
  const restaurantMenuDetails: Array<RestaurantMenuItem> = useSelector(
    (state: RootState) => state.restaurant.restaurantMenuDetails
  );

  const categoryMTypes = useSelector((state: RootState) => state.restaurant.categoryMTypes);
  const subCategoryMTypes = useSelector((state: RootState) => state.restaurant.subCategoryMTypes);

  const restaurantMenuDetailLoading = useSelector(
    (state: RootState) => state.restaurant.restaurantMenuDetailLoading
  );

  const restaurantDetailLoading = useSelector(
    (state: RootState) => state.restaurant.restaurantDetailLoading
  );

  const restaurantDetailsSuccess = useSelector(
    (state: RootState) => state.restaurant.restaurantDetailsSuccess
  );


  const showCart = useSelector(
    (state: RootState) => state.cart.showFloatingCart
  );

  const [specialMenuNames, setSpecialMenuNames] = useState<string[]>([]);
  const [previouslyOrderedMenuName, setPreviouslyOrderedMenuName] = useState<
    string[]
  >([]);

  const [categories, setCategories] = useState<Category>({});
  const [selectedCategory, setSelectedCategory] = useState<string>("");
  const menuItemDisplayFilter = useCallback((menuItem: RestaurantMenuItem) => {
    return menuItem.display == 1;
  }, []);

  const restaurantOrderTypeId = useSelector(
    (state: RootState) => state.restaurant.restaurantOrderTypeId
  );
  const restaurantOrderTypes = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail.orderTypes
  );
const isorderTypeEnabled=restaurantOrderTypes?.find((item)=>item.id===restaurantOrderTypeId)
  const currentSelectedMenuOption = useSelector(
    (state: RootState) => state.navigation.currentMenuOption
  );

  const restaurantOrderTax = useSelector(
    (state: RootState) => state.restaurant.restaurantOrderTax
  );

  const availableCoupon = useSelector((state: RootState) => state.offer.offers);

  const serviceTax = useMemo(() => {
    if (restaurantOrderTax && restaurantOrderTax?.length > 0) {
      let serviceTaxData = restaurantOrderTax.filter((u, i) => {
        return u.name === "SERVICE_TAX";
      });
      if (serviceTaxData.length > 0) {
        return serviceTaxData[0];
      } else {
        return null;
      }
    } else {
      return null;
    }
  }, [restaurantOrderTax]);

  const restaurantMenu = useMemo(() => {
    return restaurantMenuDetails;
  }, [restaurantMenuDetails]);
  const isDineInOrder = useMemo(() => {
    if (restaurantOrderTypes) {
      return (
        restaurantOrderTypes.find(
          (orderType: OrderType) => orderType.typeGroup == "D"
        )?.id == restaurantOrderTypeId
      );
    }
    return false;
  }, [restaurantOrderTypeId, restaurantOrderTypes]);

  const isPickupOrder = useMemo(() => {
    if (restaurantOrderTypes) {
      return (
        restaurantOrderTypes.find(
          (orderType: OrderType) => orderType.typeGroup == "P"
        )?.id == restaurantOrderTypeId
      );
    }
    return false;
  }, [restaurantOrderTypeId, restaurantOrderTypes]);

  const isDeliveryOrder = useMemo(() => {
    if (restaurantOrderTypes) {
      return (
        restaurantOrderTypes.find(
          (orderType: OrderType) => orderType.typeGroup == "S"
        )?.id == restaurantOrderTypeId
      );
    }
    return false;
  }, [restaurantOrderTypeId, restaurantOrderTypes]);

  const restaurantDetails = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail
  );



  // const defaultEta1 = useSelector((state: RootState) => state.restaurant.currentRestaurantDetail.defaultPickUpETA);
  //console.log({ defaultEta1 });
 
  const locationID = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail.id
  );
  const cartMenuType = useSelector(
    (state: RootState) => state.cart.cartMenuType
  );
  const isContactlessDineInOrder = useMemo(() => {
    return (
      tableId &&
      tableId.length > 0 &&
      (restaurantDetails.dining == 2 || restaurantDetails.dining == 3)
    );
  }, [restaurantDetails]);


  // const activeSessionEndTime = useSelector(
  //   (state: RootState) => state.restaurant.activeSessionEndTime
  // );

  // const nextSession = useSelector(
  //   (state: RootState) => state.restaurant?.currentRestaurantDetail.nextSession
  // );

  // const lastSession = useSelector(
  //   (state: RootState) => state.restaurant?.currentRestaurantDetail.isLastActiveSession
  // );

  // const currentRestaurantDetail = useSelector(
  //   (state: RootState) => state.restaurant.currentRestaurantDetail
  // );

  // const currentActivMenuType = useSelector((state: RootState) => state.restaurant.currentActivMenuType);
  // const deliveryETA = useSelector((state: RootState) => state.restaurant.currentRestaurantDetail.defaultDeliveryETA);
  // const pickupETA = useSelector((state: RootState) => state.restaurant.currentRestaurantDetail.defaultPickUpETA);

  // useEffect(() => {
  //   if(eventDate || !nextSession){
  //     return;
  //   }

  //   const currentOrderTypeIsActive = restaurantOrderTypes?.find(
  //     (orderType: OrderType) => orderType.typeName == menuType
  //   )

  //   const deliveryGroupName = restaurantOrderTypes?.find((orderType: OrderType) => orderType.typeGroup == 'S')?.typeName;
  //   const pickupGroupName = restaurantOrderTypes?.find((orderType: OrderType) => orderType.typeGroup == 'P')?.typeName;

  //   const defaultEta = currentActivMenuType?.toLowerCase() === deliveryGroupName?.toLowerCase() ? deliveryETA : currentActivMenuType?.toLowerCase() === pickupGroupName?.toLowerCase() ? pickupETA : '0';
  
  //   const sessionData = {
  //     activeSessionEndTime: activeSessionEndTime, // Example active session end time S P
  //     // nextSession: {
  //     //   nextSessionStartTime: '13:15:00', // Example next session start time
  //     //   nextSessionDay: "Saturday", // Can be "Today" or "Tomorrow"
  //     // },
  //     nextSession: nextSession,
  //     isLastSession: lastSession, // Set to true to stop scheduling further tasks
  //     isActiveOrderType: currentOrderTypeIsActive?.isEnabled == 1,
  //     menuType: currentActivMenuType,
  //     restaurantId: currentRestaurantDetail?.id
  //   };    
  //  // console.log({ currentActivMenuType, nextSession });
    
  //   // nextSession && currentActivMenuType && scheduleTask(
  //   //   sessionData,
  //   //   dispatch,
  //   //   performTaskAction,
  //   //   updateTaskAction,
  //   //   defaultEta,
  //   // );
  // }, [activeSessionEndTime, eventDate, currentActivMenuType]);

  
  const isExistingContactlessDineInOrder = useMemo(() => {
    return Boolean(
      orderId &&
      tableId &&
      tableId.length > 0 &&
      (restaurantDetails.dining == 2 || restaurantDetails.dining == 3)
    );
  }, [restaurantDetails]);

  const [isSearching, setIsSearching] = useState(false);
  const [isPopupNotShown, setIsPopupNotShown] = useState(true);


  const dineInType = restaurantDetails.orderTypes?.filter(
    (d) => d.typeGroup === "D"
  )[0];
  const isContactlessDineInOrdernew = useMemo(() => {
      if (restaurantOrderTypes) {
        return (
          (restaurantDetails.dining == 2 ||
            restaurantDetails.dining == 3) &&
          restaurantOrderTypes.find(
            (orderType: OrderType) => orderType.typeGroup == "D"
          )?.id == restaurantOrderTypeId &&
          tableId &&
          tableId.length > 0 && menuType=="DineIn"
        );
      }
      return false;
    }, [restaurantOrderTypeId, restaurantOrderTypes, restaurantDetails]);
  useEffect(() => {
    if(isPickupOrder ||isDeliveryOrder){
    const token ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJob3N0IjoiaHR0cHM6Ly9hcHAubWFnaWxodWIuY29tIiwiaWQiOiI2NjY0Yjc4Njc0YWY2MmYwMjViMWY3MzUiLCJhY2NJZCI6IjYxOGE4ZDYzNmIzZTU0MDAwNGQ1NzJlOCIsImlhdCI6MTcxNzg3ODg2MH0.ALCFXDOTZDXX8N2V9-UAhn6ihwwpGgRHW2OrA_yCt0o";
    const loadScript = () => {
      window.Chatty = function(c) { window.Chatty._.push(c) };
      window.Chatty._ = [];
      window.Chatty.url = 'https://widget.gallabox.com';
      window.Chatty.hash = token;
      const h = document.getElementsByTagName('head')[0];
      const j = document.createElement('script');
      j.async = true;
      j.src = 'https://widget.gallabox.com/chatty-widget.min.js?_=' + Math.random();
      h.appendChild(j);
    };
    if (window.Chatty) {
    } else {
      loadScript(); 
    }
    return () => {
      delete window.Chatty;
    };
  }
  }, [isPickupOrder,isDeliveryOrder]);

  useEffect(() => {
    if (
      isContactlessDineInOrder &&
      guestUser === null &&
      dineInType &&
      !tableId
    ) {      
      history.push(
        getContactlessDineinLandingPage(
          merchantType,
          merchantSlug,
          tableId,
          dineInType?.typeName
        )
      );
    }
  }, [guestUser, isContactlessDineInOrder, tableId]);

  useEffect(() => {
    if (menuLocationState && menuLocationState.id) {
      setTimeout(() => {
        const item = document.querySelector(".restore-" + menuLocationState.id);
        if (item) {
          item.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
        }
      }, 10);
    }
  }, []);

  // Bottom Navigation Active option logic
  useEffect(() => {
    if (
      (isContactlessDineInOrder && currentSelectedMenuOption != "Menu") ||
      !isSearching
    ) {
      setCurrentRestaurantDishViewType("All Items");
      setCurrentRestaurantDishViewTypeExclusive("Exclusive");
      setCurrentCategory("");
      dispatch(setMenuOption("Menu"));
    } else if (
      (isContactlessDineInOrder &&
        menuLocationState &&
        menuLocationState.showSearch == true &&
        currentSelectedMenuOption != "Search") ||
      isSearching
    ) {
      dispatch(setMenuOption("Search"));
    }
  }, [menuLocationState, isContactlessDineInOrder, isSearching]);

  const UserId = localStorage.getItem("USER_ID");

  const specialMenuItemFilter = useCallback((menuItem: RestaurantMenuItem) => {
    return menuItem.isSpecial;
  }, []);

  const perviouslyOrderedMenuItemFilter = useCallback(
    (menuItem: RestaurantMenuItem) => {
      return menuItem.isPreviouslyOrdered;
    },
    []
  );



  const currentReservation = localStorage.getItem(
    "CURRENT_CHECKIN_RESERVATION_ID"
  );

  const isCheckInwithData = localStorage.getItem("CHECKIN_WITH_DATA");

  const restaurantCountry = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail.country
  );
  useEffect(() => {
    if (menuLocationState && menuLocationState.showSearch == true) {
      setIsSearching(true);
    }
    if (!isMobile) {
      setIsSearching(true);
    }
  }, [menuLocationState]);

  const [showNoItemsModal, setShowNoItemsModal] = useState(false);

  const isSpecialMenuAvailable = useMemo(() => {
    return (
      restaurantMenu &&
      restaurantMenu.filter(specialMenuItemFilter).filter(menuItemDisplayFilter)
        .length > 0
    );
  }, [restaurantMenu]);

  const isPreviouslyOrderedMenuAvailable = useMemo(() => {
    return (
      restaurantMenu &&
      restaurantMenu
        .filter(perviouslyOrderedMenuItemFilter)
        .filter(menuItemDisplayFilter).length > 0
    );
  }, [restaurantMenu]);

  const isSpecialMenuTypeAvailable = useCallback(
    (type: string) => {
      return (
        restaurantMenu
          .filter(specialMenuItemFilter)
          .filter((menu) => menu.specialName == type)
          .filter(menuItemDisplayFilter).length > 0
      );
    },
    [restaurantMenu]
  );

  // useEffect(() => {
  //   const unlisten = history.listen((location, action) => {
  //     if (action === 'POP' || 'PUSH') {
  //       console.log('calf');

  //       history.go(0);
  //     }
  //   });
  //   return () => unlisten();
  // }, [history]);

  const isPreviouslyOrderedAvailable = useCallback(
    (type: string) => {
      return (
        restaurantMenu
          .filter(perviouslyOrderedMenuItemFilter)
          .filter((menu) => menu.isPreviouslyOrdered == 1)
          .filter(menuItemDisplayFilter).length > 0
      );
    },
    [restaurantMenu]
  );

  // const isCategoryAvailable = useCallback(
  //   (category: string) => {
  //     return restaurantMenu.filter((menu) => menu.category == category);
  //   },
  //   [categories]
  // );
  const getSpecialMenuText = useCallback(() => {
    if (specialMenuNames.length > 0 && isSpecialMenuAvailable) {
      return ["Special Menu"];
    } else {
      return [];
    }
  }, [specialMenuNames, isSpecialMenuAvailable]);

  const getPreviouslyOrderedMenuText = useCallback(() => {
    if (
      previouslyOrderedMenuName.length > 0 &&
      isPreviouslyOrderedMenuAvailable
    ) {
      return ["Previously Ordered"];
    } else {
      return [];
    }
  }, [previouslyOrderedMenuName, isPreviouslyOrderedMenuAvailable]);

  const restaurantDishViewTypes = [
    "All Items",
    ...getSpecialMenuText(),
    ...getPreviouslyOrderedMenuText(),
    // "Previously Ordered",
    // "Best Sellers",
    // "Options",
  ];

  const [currentRestaurantDishViewType, setCurrentRestaurantDishViewType] =
    useState<string>("All Items");

    const [currentRestaurantDishViewTypeExclusive, setCurrentRestaurantDishViewTypeExclusive] =
    useState<string>("Exclusive");

  const isSpecialMenuView = useCallback(() => {
    return currentRestaurantDishViewType == "Special Menu";
  }, [currentRestaurantDishViewType]);

  const isPreviouslyOrderedMenuView = useCallback(() => {
    return currentRestaurantDishViewType == "Previously Ordered";
  }, [currentRestaurantDishViewType]);

  const currentRestaurantMenuType = useSelector(
    (state: RootState) => state.restaurant.currentMenuType
  );

  // const [merchantDetails, setMerchantDetails] = useState({
  //   headerFunctionType: "favourite",
  //   borderBottom: false,
  // });

  const restaurantMenuCategories = useSelector(
    (state: RootState) => state.restaurant.restaurantMenuCategories
  );

  const isSyncUpdated = useSelector((state: RootState) => state.scheduler.isSyncUpdated);

  const restaurantCategories = useMemo(() => {
    return (
      restaurantMenuCategories &&
      restaurantMenuCategories.filter((category) =>
        Object.keys(categories).includes(category)
      )
    );
  }, [restaurantMenuCategories, categories]);

  const [merchantDetails, setMerchantDetails] = useState({
    headerFunctionType: "favourite",
    borderBottom: false,
  });
  const [showSpeicalNotePromptID, setShowSpeicalNotePromptID] =
    useState<string>("");
  const [customisationItemId, setCustomisationItemId] = useState("");

  const [dishes, setDishes] = useState<RestaurantMenuItem[]>([]);

  const [specialDishes, specialSetDishes] = useState<RestaurantMenuItem[]>([]);


  const [currentCategory, setCurrentCategory] = useState("");
  const [searchText, setSearchText] = useState("");

  // const [currentType, setCurrentType] = useState("Menu");
  // const [showMenu, setShowMenu] = useState({ x: 0, y: 0, state: false });

  const [isFiltering, setIsFiltering] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);
  const [checkInFloatingBar, setcheckInFloatingBar] = useState(true);
  const [selectedFilters, setSelectedFilters] = useState(Object());

  useEffect(() => {
    if (
      !isMobile &&
      searchText?.length > 0 &&
      (location?.pathname === `/restaurant/${merchantSlug}` ||
        location?.pathname === `/restaurant/${merchantSlug}/`)
    ) {
      props.dishData(dishes);
    }
  }, [isMobile, dishes]);

  const isMenuView = useCallback(
    (menuType: string) => {
      return (
        restaurantDetails.orderTypes?.some((orderType) => {
          return (
            !tableId &&
            orderType.typeName == menuType &&
            orderType.typeGroup == "D"
          );
        }) || false
      );
      // return restaurantDetails.digitalMenu == 1;
    },
    [restaurantDetails]
  );
  const isMenuAdd = useCallback(
    (menuType: string) => {
      return restaurantDetails.orderTypes?.some((orderType) => {
        return (
          !tableId &&
          orderType.typeName == menuType &&
          orderType.isEnabled == 1 &&
          orderType.typeGroup != "D"
        );
      }) || tableId
        ? true
        : false;
    },
    [restaurantDetails]
  );
  const [
    setVisibleCategories,
    toggleCategoryVisibility,
    isCategoryVisible,
    showCategory,
  ] = useVisibility();
  const [
    setVisibleSubCategories,
    toggleSubCategoryVisibility,
    isSubCategoryVisible,
    showSubCategory,
  ] = useVisibility();

  const [
    setVisibleSpecialMenus,
    toggleSpecialMenuVisibility,
    isSpecialMenuVisible,
    showSpecialMenu,
  ] = useVisibility();

  const [
    setVisiblePreviouslyOrderedMenus,
    togglePreviouslyOrderedMenuVisibility,
    isPreviouslyOrderedMenuVisible,
    showPreviouslyOrderedMenu,
  ] = useVisibility();

  const cartItems: Array<CartItem> = useSelector(
    (state: RootState) => state.cart.cart.items
  );

  const [logEvent] = useEventLogger();
  //console.log(location.state==undefined );

  useEffect(() => {
    // Get Restaurant Details

    if (isMobile && restaurantDetails.locationSlug !== merchantSlug) {
      dispatch(getRestaurantDetails(merchantSlug));
    }

    // Initialize View Menu - Section Type DropDown
    setSelectedMenuType(menuType);

    // Log Menu View Event
    // logEvent("restaurant_menu_view", {
    //   merchant: merchantSlug,
    // } as RESTAURANT_MENU_VIEW_DETAILS);
  }, []);

  useEffect(() => {
    if (props.searchText) {
      setSearchText(props.searchText);
    } else {
      setSearchText("");
    }
  }, [props.searchText]);
  useEffect(() => {

    // Start Cart if Not Initialized
    if (
      location.state &&
      location.state.isExistingCart &&
      isContactlessDineInOrder
    ) {
      dispatch(
        startEmptyCart({
          menuType: menuType,
          restaurantSlug: merchantSlug,
          clearCartItems: false,
          merchantType: merchantType,
          cartType: "RUNNING_CART",
        })
      );
      dispatch(startEmptyCartOrder())
    } else {
      isMenuAdd(menuType) &&
        dispatch(
          startEmptyCart({
            menuType: menuType,
            restaurantSlug: merchantSlug,
            clearCartItems: false,
            merchantType: merchantType,
          })
        );
        dispatch(startEmptyCartOrder())
    }

    if (menuType && !!restaurantDetails?.id && restaurantDetails?.id != "" && !restaurantDetailLoading && isMobile) {
      // If Coming from Menu Details , Disable Request
      if (
        menuLocationState &&
        Object.keys(menuLocationState).length > 0 &&
        restaurantMenu.length > 0 &&
        !restaurantDetailLoading
      ) {
        if (
          location &&
          location.state &&
          location.state.query === "tableSide"
        ) {
          dispatch(
            getRestaurantMenuDetails({
              type: menuType ? menuType : "DINE_IN",
              locationId: restaurantDetails.id,
              customerId: UserId,
              searchText:
                location.state.keyword && location.state.keyword != null
                  ? location.state.keyword
                  : null,
              visibleTo: "C",
            })
          );
        }

        menuLocationState.loadMenuRequired &&
          dispatch(
            getRestaurantMenuDetails({
              type: menuType ? menuType : "DINE_IN",
              locationId: restaurantDetails.id,
              customerId: UserId,
              searchText:
                location.state.keyword && location.state.keyword != null
                  ? location.state.keyword
                  : null,
              visibleTo: "C",
            })
          );
      }else if(eventDate && menuType){
        dispatch(
          getRestaurantMenuDetailsbyDate({
            type: menuType ,
            locationId: restaurantDetails.id,
            customerId: UserId,
            searchText:location.state == undefined ? null : location.state.keyword,
            visibleTo: "C",
            eventSlug:eventDate
          })
        );

      } else {
        // if (restaurantDetails.locationSlug !== merchantSlug) {
        dispatch(
          getRestaurantMenuDetails({
            type: menuType ? menuType : "DINE_IN",
            locationId: restaurantDetails.id,
            customerId: UserId,
            searchText:
              location.state == undefined ? null : location.state.keyword,
            visibleTo: "C",
          })
        );
        // }
      }
    }
  }, [restaurantDetails.id,eventDate]);

  useEffect(() => {
    if (restaurantMenu && restaurantMenu.length > 0) {
      setDishes([...restaurantMenu]);
      specialSetDishes([...restaurantMenu]);
      loadSpecialMenuNames();
      loadPreviouslyOrderedMenuNames();
    }
  }, [restaurantMenu, isSyncUpdated]);

  useEffect(() => {
    // Update Category and SubCategory List on Menu API Change
   // menu category filter
    // const { categoryTypes, subCategoryTypes } =
    //   getAvailableCatgorySubCategory(restaurantMenu);
    setCategories(categoryMTypes);
    setVisibleCategories(Object.keys(categoryMTypes));
    setVisibleSubCategories(Object.keys(subCategoryMTypes));
  }, [restaurantMenu,subCategoryMTypes,categoryMTypes,isSyncUpdated]);

  useEffect(() => {
    //console.log(selectedFilters);
    let present = Object.keys(selectedFilters).some(
      (i) => selectedFilters[i] === true
    );
    // console.log(present);
    if (present) setIsFiltered(true);
    else setIsFiltered(false);
  }, [selectedFilters]);

  // Filters
  useEffect(() => {
    if (!isSearching) {
      if (currentCategory.length > 0) {
        // Category Based Filter
        let menu: Array<RestaurantMenuItem> = [];
        restaurantMenu?.map((menuDetail) => {
          if (menuDetail.category) {
            if (menuDetail.category === currentCategory) {
              menu.push(menuDetail);
            }
          } else {
            if (currentCategory == menuDetail.subCategory) {
              menu.push(menuDetail);
            }
          }
        });
        setDishes([...menu]);
        specialSetDishes([...menu]);
      } else {
        if (restaurantMenu && restaurantMenu.length > 0) {
          setDishes([...restaurantMenu]);
          specialSetDishes([...restaurantMenu]);
        }
      }
    } else if (isSearching) {
      // Keyword based Search
      if (currentCategory.length > 0 && searchText == "") {
        var tempDishData = restaurantMenu.filter(
          (item) =>
            item?.itemName
              ?.toLocaleLowerCase()
              ?.includes(searchText.toLocaleLowerCase()) &&
            (item.category === currentCategory ||
              item.subCategory === currentCategory)
        );
        // Category Based Filter
        // let menu: Array<RestaurantMenuItem> = [];
        // restaurantMenu?.map((menuDetail) => {
        //   if (menuDetail.category) {
        //     if (menuDetail.category === currentCategory) {
        //       menu.push(menuDetail);
        //     }
        //   } else {
        //     if (currentCategory == menuDetail.subCategory) {
        //       menu.push(menuDetail);
        //     }
        //   }
        // });
        // console.log({isSearching,currentCategory,tempDishData});
        setDishes([...tempDishData]);
      } else {
        if (restaurantMenu && restaurantMenu.length > 0) {
          var tempDishData = restaurantMenu.filter((item) =>
            item?.itemName
              ?.toLocaleLowerCase()
              ?.includes(searchText.toLocaleLowerCase())
          );
          setDishes([...tempDishData]);
        }
      }
    } else {
      setDishes(restaurantMenu);
      specialSetDishes([...restaurantMenu]);
    }
  }, [currentCategory, searchText, isSearching]);

  const getMenuItemImageUrl = useCallback((imgId: string, ext: string) => {
    return process.env.REACT_APP_IMAGE_URL + "img" + "/" + imgId + "." + ext;
  }, []);

  const submitSpecialNote = useCallback(
    (saveComment: boolean, note: string) => {
      saveComment && dispatch(saveItemComments(showSpeicalNotePromptID, note));
      setShowSpeicalNotePromptID("");
    },
    [showSpeicalNotePromptID]
  );

  interface RenderDishCardProps {
    menuDetail: RestaurantMenuItem;
    ItemUpdate(itemId: string, quantity: string): void;
  }

  const cartvalue = useSelector(
    (state: RootState) => state.offer.checkofferresult
  );

  useEffect(() => {
    //console.log("useEffect first")
    if (dishes.length > 0) {
      for (let i = 0; i < dishes.length; i++) {
        const value = dishes[i];
        if (
          cartvalue?.offers?.length > 0 &&
          value.itemId ===
          cartvalue.offers[0]?.offerAttributes.itemDetails.itemCode
        ) {
          let isDiscountApplied = false;
          let offerData = undefined;
          let price = Number(value.price);
          let totalDiscountPrice = 0;
          let totalItemCount = Number(cartvalue.quantity)
            ? Number(cartvalue.quantity)
            : 1;

          if (
            cartvalue?.offers?.length > 0 &&
            cartvalue.offers[0]?.offerAttributes.itemDetails.itemCode
          ) {
            //console.log("value--", value.itemBasedOffers[0].offerAttributes.itemDetails.scaleLevel);
            let discountprice = "";
            // console.log("offerType -->",cartvalue.offers[0].offerType,value.itemBasedOffers[0].offerType);
            if (cartvalue && cartvalue.offers[0].offerType === "PERCENT") {
              let percentcalculation =
                (cartvalue.offers[0].offerRate / 100) *
                (price * totalItemCount);

              discountprice =
                value.itemBasedOffers[0].offerAttributes.itemDetails
                  .scaleLevel === 0
                  ? Number(cartvalue.offers[0].maxDiscount) < percentcalculation
                    ? String(cartvalue.offers[0].maxDiscount)
                    : String(percentcalculation)
                  : String(percentcalculation);
              //  console.log("discountprice --",cartvalue);
            } else if (
              cartvalue &&
              cartvalue.offers[0].offerType === "FLATFEE"
            ) {
              discountprice = String(cartvalue.offers[0].maxDiscount);
              // console.log("discountprice -->", discountprice);
            }

            if (price) {
              totalDiscountPrice =
                price * totalItemCount -
                (discountprice && Number(discountprice)
                  ? Number(discountprice)
                  : 0);
            }
            isDiscountApplied = true;
            offerData = cartvalue.offers[0];
          }

          dispatch(
            updateCartItem(
              value.itemId,
              String(
                getItemPrice(
                  totalDiscountPrice
                    ? totalDiscountPrice
                    : price * totalItemCount
                )
              ),
              isDiscountApplied,
              undefined,
              totalItemCount,
              offerData
            )
          );
        }
      }
    }
  }, [cartvalue]);

  function getItemPrice(price: number) {
    if (restaurantCountry.length > 0) {
      if (restaurantCountry == "US") {
        return getDecimalPlacedPriceString(price);
      } else {
        return getDecimalPlacedPriceString(price);
      }
    } else {
      return price;
    }
  }

  function ItemUpdate(itemId: string, quantity: string) {
    if (UserId) {
      dispatch(
        requestCheckOffers({
          customerId: UserId,
          itemId: itemId,
          quantity: quantity,
          locationId: locationID,
          orderType: cartMenuType || paramsData?.menuType,
        })
      );
    }
  }

  const [customizePopup,setCustomizePopup] = useState<boolean>(false)
  const [customizePopupPreview,setCustomizePopupPreview] = useState<boolean>(false)

  // Initialize scheduler when component mounts
  useEffect(() => {
      //console.log('Initializing scheduler in RestaurantHome');
      initializeScheduler();
  
      // Cleanup scheduler when component unmounts
      return () => {
        //console.log('Cleaning up scheduler in RestaurantHome');
        cleanupScheduler();
      };
  }, [restaurantMenuDetails, restaurantDetails, restaurantDetailLoading]);

  const cutOffTimeExceeds = React.useCallback((orderType:string) => {
    const item =  restaurantDetails?.orderTypes?.filter(item => item.typeName === orderType && item.isEnabled == 1);
    const typeGroup = item && item[0]?.typeGroup
    return typeGroup == 'P' ? restaurantDetails.pickupCutOffTimeExceeds == 0  : typeGroup == 'S' ? restaurantDetails.deliveryCutOffTimeExceeds == 0 : false
  }, [restaurantDetails])

  const RenderDishCard = useCallback(
    (data: RenderDishCardProps) => {
      return (
        <div className={`restore-${data.menuDetail.itemId}`}>
          {isMobile || isContactlessDineInOrder ? (
            <DishCardMobile
              setCustomisationItemId={setCustomisationItemId}
              setCustomisationPopup={(data:boolean) => {
                //window.history.pushState({}, "");
                setCustomizePopup(data);
              }}
              setPreviewItemPopup={(data:boolean) => {
                //window.history.pushState({}, "");
                setCustomizePopupPreview(data);
              }}
              setShowSpeicalNotePromptID={setShowSpeicalNotePromptID}
              itemDetail={data.menuDetail}
              customizable={data.menuDetail.customization ? true : false}
              getMenuItemImageURL={getMenuItemImageUrl}
              menuAdd={isMenuAdd(menuType)}
              menuView={isMenuView(menuType)}
              menuType={isMobile || isContactlessDineInOrder ? menuType : props.menuType}
              ItemUpdate={data.ItemUpdate}
              cutOffTimeExceeds={cutOffTimeExceeds(isMobile || isContactlessDineInOrder ? menuType : props.menuType)}
            />
          ) : (
            <DishCard
              setCustomisationItemId={setCustomisationItemId}
              setCustomisationPopup={setCustomizePopup}
              setPreviewItemPopup={setCustomizePopupPreview}
              setShowSpeicalNotePromptID={setShowSpeicalNotePromptID}
              itemDetail={data.menuDetail}
              customizable={data.menuDetail.customization ? true : false}
              getMenuItemImageURL={getMenuItemImageUrl}
              menuAdd={isMobile ? isMenuAdd(menuType) : isMenuAdd(props.menuType)}
              menuView={isMobile ? isMenuView(menuType) : (isMenuView(props.menuType) || props.menuType == 'Menu')}
              menuType={isMobile ? menuType : props.menuType}
              ItemUpdate={data.ItemUpdate}
              cutOffTimeExceeds={cutOffTimeExceeds(isMobile || isContactlessDineInOrder ? menuType : props.menuType)}
            />
          )}
        </div>
      );
    },
    [
      showSpeicalNotePromptID,
      restaurantMenu,
      restaurantMenuTypes,
      menuType,
      searchText,
      props,
      cutOffTimeExceeds,
      restaurantDetails,
      isSyncUpdated
    ]
  );
  const SpeciaMenucard = useCallback(
    (data: RenderDishCardProps) => {
      return (
        <div className={`restore-${data.menuDetail.itemId}`}>
          {isMobile || isContactlessDineInOrder ? (
            <SpecialMenu
              setCustomisationItemId={setCustomisationItemId}
              setCustomisationPopup={(data:boolean) => {
                //window.history.pushState({}, "");
                setCustomizePopup(data);
              }}
              setPreviewItemPopup={(data:boolean) => {
                //window.history.pushState({}, "");
                setCustomizePopupPreview(data);
              }}
              setShowSpeicalNotePromptID={setShowSpeicalNotePromptID}
              itemDetail={data.menuDetail}
              customizable={data.menuDetail.customization ? true : false}
              getMenuItemImageURL={getMenuItemImageUrl}
              menuAdd={isMenuAdd(menuType)}
              menuView={isMenuView(menuType)}
              menuType={isMobile || isContactlessDineInOrder ? menuType : props.menuType}
              ItemUpdate={data.ItemUpdate}
              cutOffTimeExceeds={cutOffTimeExceeds(isMobile || isContactlessDineInOrder ? menuType : props.menuType)}
            />
          ) : null}
        </div>
      );
    },
    [
      showSpeicalNotePromptID,
      restaurantMenu,
      restaurantMenuTypes,
      menuType,
      searchText,
      props,
      cutOffTimeExceeds,
      restaurantDetails,
      isSyncUpdated
    ]
  );
  const categorySubCategoryFilter = useCallback(
    (menuDetail: RestaurantMenuItem, category: string, subCategory: string) => {
      // Apply Category and SubCategory Filters
      if (menuDetail.category) {
        return (
          menuDetail.subCategory == subCategory &&
          menuDetail.category == category
        );
      } else {
        return menuDetail.subCategory == subCategory && category == "Others";
      }
    },
    []
  );

  const loadSpecialMenuNames = useCallback(() => {
    let specialNames: string[] = [];
    restaurantMenu.filter(specialMenuItemFilter).map((menuItem) => {
      if (!specialNames.includes(menuItem.specialName)) {
        specialNames.push(menuItem.specialName);
      }
    });
    // console.log(specialNames);
    setSpecialMenuNames([...specialNames]);
    setVisibleSpecialMenus([...specialNames]);
  }, [restaurantMenu, specialMenuNames, isSyncUpdated]);

  const loadPreviouslyOrderedMenuNames = useCallback(() => {
    let specialNames: string[] = [];
    restaurantMenu.filter(perviouslyOrderedMenuItemFilter).map((menuItem) => {
      if (!specialNames.includes(menuItem.subCategory)) {
        specialNames.push(menuItem.subCategory);
      }
    });

    // console.log(specialNames);
    setPreviouslyOrderedMenuName([...specialNames]);
    setVisiblePreviouslyOrderedMenus([...specialNames]);
  }, [restaurantMenu, specialMenuNames, isSyncUpdated]);

  const MenuTypeView = () => {
    // console.log({currentRestaurantDishViewType});

    switch (currentRestaurantDishViewType) {
      case "All Items":
        return <AllMenus />;

      case "Special Menu":
        return <SpecialMenus />;

      case "Recommendation":
        return <PreviouslyOrderedMenus />;

      case "Previously Ordered":
        return <PreviouslyOrderedMenus />;

      default:
        break;
    }
  };

  const AllMenus = () => {
    return (
      <Fragment>
        {searchText.length == 0 &&
          restaurantCategories
            ?.filter((category) => {
              return currentCategory.length == 0
                ? true
                : category == currentCategory;
            })
            .map((category: string,index:number) => {
              return (
                <Fragment key={category+index}>
                  <div
                    style={{
                      display: "flex",
                      width: "90%",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className="category-head"
                      onClick={() => {
                        toggleCategoryVisibility(category);
                      }}
                    >
                      <span>{category}</span>
                    </div>
                    <div
                      style={{
                        flexBasis: "20%",
                        // textAlign: '-webkit-right'
                      }}
                      onClick={() => {
                        toggleCategoryVisibility(category);
                      }}
                    >
                      <div
                        style={{ cursor: "pointer", marginLeft: "auto" }}
                        className={
                          isCategoryVisible(category)
                            ? "arrow-up"
                            : "arrow-up visibleCategory"
                        }
                      ></div>
                    </div>
                  </div>
                  {isCategoryVisible(category) ? (
                    <Fragment>
                      {categories[category]?.subCategories?.length > 0 &&
                      (
                        <Fragment>
                          {categories[category]?.subCategories?.map(
                            (subCategory: string, index: number) => {
                              return (
                                <div key={index}>
                                  <div
                                    className="subcategory-head"
                                    style={{ width: "90%" }}
                                    onClick={() =>
                                      toggleSubCategoryVisibility(subCategory)
                                    }
                                  >
                                    <span
                                      className={`restore-${subCategory
                                        ?.toLocaleUpperCase()
                                        ?.replace(/[^a-zA-Z]/g, "")}`}
                                      style={{
                                        width: "80%",
                                        paddingLeft: "5.3%",
                                      }}
                                    >
                                      {subCategory?.toLocaleUpperCase()}
                                    </span>
                                    <div className="sub-category-icon">
                                      {isSubCategoryVisible(subCategory) ? (
                                        <MinusIcon />
                                      ) : (
                                        <PlusIcon />
                                      )}
                                    </div>
                                  </div>
                                  <div className="dishCardsContainer">
                                    {isSubCategoryVisible(subCategory) ? (
                                      <Fragment>
                                        {dishes
                                          ?.filter(
                                            (
                                              menuDetail: RestaurantMenuItem
                                            ) => {
                                              // Apply Category and SubCategory Filters
                                              if (menuDetail?.category) {
                                                return (
                                                  menuDetail?.subCategory ==
                                                    subCategory &&
                                                  menuDetail?.category ==
                                                    category
                                                );
                                              } else {
                                                return (
                                                  menuDetail?.subCategory ==
                                                    subCategory &&
                                                  category == "Others"
                                                );
                                              }
                                            }
                                          )
                                          .filter(menuItemDisplayFilter)
                                          .map(
                                            (
                                              menuDetail: RestaurantMenuItem,
                                              index
                                            ) => {
                                              return (
                                                <RenderDishCard
                                                  menuDetail={menuDetail}
                                                  key={menuDetail?.itemId}
                                                  ItemUpdate={ItemUpdate}
                                                />
                                              );
                                            }
                                          )}
                                      </Fragment>
                                    ) : null}
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </Fragment>
                      )} 

                      {(
                        <Fragment>
                          <div className="dishCardsContainer">
                            {dishes
                              .filter((dish) => {
                                if (
                                  dish?.category == null &&
                                  dish?.subCategory == category
                                ) {
                                  if (dish?.subCategory == currentCategory) {
                                    return true;
                                  }
                                  return true;
                                } else {
                                  return false;
                                }
                              })
                              .filter(menuItemDisplayFilter)
                              .map(function (
                                menuDetail: RestaurantMenuItem,
                                index: number
                              ) {
                                return (
                                  <RenderDishCard
                                    menuDetail={menuDetail}
                                    key={menuDetail?.itemId}
                                    ItemUpdate={ItemUpdate}
                                  />
                                );
                              })}
                          </div>
                        </Fragment>
                      )}
                    </Fragment>
                  ) : null}
                </Fragment>
              );
            })}
      </Fragment>
    );
  };

  const SpecialMenus = () => {
    return (
      <Fragment>
        {searchText.length == 0 &&
          isSpecialMenuView() &&
          specialMenuNames
            ?.filter((specialMenu) => isSpecialMenuTypeAvailable(specialMenu))
            .map((specialMenu: string) => {
              return (
                <Fragment key={specialMenu}>
                  <div style={{ display: "flex" }}>
                    <div
                      className="category-head"
                      onClick={() => toggleSpecialMenuVisibility(specialMenu)}
                    >
                      <span>{specialMenu}</span>
                    </div>
                    <div
                      style={{
                        flexBasis: "20%",
                        margin: "auto",
                        cursor: "pointer",
                      }}
                      onClick={() => toggleSpecialMenuVisibility(specialMenu)}
                    >
                      <div
                        style={{ margin: "0 auto 0" }}
                        className={
                          isSpecialMenuVisible(specialMenu)
                            ? "arrow-up"
                            : "arrow-up visiblespecialMenu"
                        }
                      ></div>
                    </div>
                  </div>
                  {isSpecialMenuVisible(specialMenu) ? (
                    <div className="dishCardsContainer">
                      {dishes
                        ?.filter((menuDetail: RestaurantMenuItem) => {
                          return (
                            menuDetail.isSpecial &&
                            menuDetail.specialName == specialMenu
                          );
                        })
                        .filter(menuItemDisplayFilter)
                        .map((menuDetail: RestaurantMenuItem, index) => {
                          return (
                            <RenderDishCard
                              menuDetail={menuDetail}
                              key={menuDetail.itemId}
                              ItemUpdate={ItemUpdate}
                            />
                          );
                        })}
                    </div>
                  ) : null}
                </Fragment>
              );
            })}
      </Fragment>
    );
  };

  const PreviouslyOrderedMenus = () => {
    return (
      <Fragment>
        {/* {searchText.length == 0 &&
          isPreviouslyOrderedMenuView() &&
          previouslyOrderedMenuName
            // .filter((specialMenu) => isPreviouslyOrderedAvailable(specialMenu))
            .map((specialMenu: string) => {
              console.log("Special Menuu:::", specialMenu);

              return ( */}
        {/* <Fragment key={specialMenu}>
                  <div
                    className="category-head"
                    onClick={() =>
                      togglePreviouslyOrderedMenuVisibility(specialMenu)
                    }
                  >
                    <span>{specialMenu}</span>
                    <div
                      className={
                        isPreviouslyOrderedMenuVisible(specialMenu)
                          ? "arrow-up"
                          : "arrow-up visiblespecialMenu"
                      }
                    ></div>
                  </div> */}

        {/* {isPreviouslyOrderedMenuVisible(specialMenu) ? ( */}
        <div className="dishCardsContainer " style={{ marginTop: "10px" }}>
          {dishes
            ?.filter((menuDetail: RestaurantMenuItem) => {
              return menuDetail.isPreviouslyOrdered === 1;
            })
            .filter((menuDetail: RestaurantMenuItem) => {
              return menuDetail.display === 1;
            })
            .map((menuDetail: RestaurantMenuItem, index) => {
              return (
                <RenderDishCard
                  menuDetail={menuDetail}
                  key={menuDetail.itemId}
                  ItemUpdate={ItemUpdate}
                />
              );
            })}
        </div>
        {/* // ) : null} */}
      </Fragment>
      //         );
      //       })}
      // </Fragment>
    );
  };

  let isCheckInFloatingBar = localStorage.getItem("CHECKIN_WITH_DATA");
  const [requestOption, setRequestOption] = useState<string>("");

  const dineInOrderId = useMemo(() => {
    if (restaurantOrderTypes) {
      return (
        restaurantOrderTypes.find(
          (orderType: OrderType) => orderType.typeGroup == "D"
        )?.id || ""
      );
    }
    return "";
  }, [restaurantOrderTypes]);

  const AppAuth = useContext(AuthContext);

  const orderDetails = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail
  );

  const orderDetail = useSelector(
    (state: RootState) => state.order.currentOrderDetail
  );

  const offers = useSelector((state: RootState) => state.offer);
  const selectedoffersId = offers.offerId;
  const offerValidSuccess = offers.offerValidSuccess;
  const offerValidLoading = offers.offerValidLoading;
  const validityError = offers.offerValidityError;
  const isValidOffer = offers.offerValidSuccess;
  const isValidOfferNot = offers.offerValidFailure;
  const selectedOffer = offers.selectedOffer;
  const offersList = useSelector((state: RootState) => state.offer.offers);

  const cartUrl = useSelector((state: RootState) => state.cart.cartURL);

  const [loginRequestPopup, setloginRequestPopup] = useState(false);
  const [priceValidationError, setpriceValidationError] = useState(false);

  const [currOffer, setCurrOffer] = useState<any>(null);
  // console.log("currOffer", currOffer);
  let paramsData = useParams<any>();
  // const [
  //   makeOrder,
  //   totalItemsubTotal,
  //   totalOrderPrice,
  //   totalTaxAndCharges,
  //   totalItemTaxAmount,
  //   tipAmount,
  //   packagingCharge,
  // ] = usePlaceOrder();
  const [makeOrder,updateOrder,orderTotal,totalItemsubTotal,orderTotals,tipAmount,discountAmount,deliveryFee] = useOnlinePlaceOrder();


  useEffect(() => {
    if (
      !offerValidLoading &&
      offerValidSuccess &&
      selectedoffersId == currOffer?.id &&
      isValidOffer &&
      cartUrl
    ) {
      if (isContactlessDineInOrder) {
        if (
          orderDetail &&
          orderDetail.totals[0].value >= currOffer?.minOrderAmount
        ) {
          dispatch(setOfferData(currOffer));
          dispatch(clearOfferValidityData());
          history.push(
            getContactlessDineInOrderStatusURL(
              paramsData.merchantType,
              paramsData.merchantSlug,
              paramsData.tableId,
              paramsData.orderId
            ),
            { offerdetails: currOffer }
          );
        } else {
          setpriceValidationError(true);
        }
      } else {
        if (totalItemsubTotal >= currOffer?.minOrderAmount) {
          dispatch(setOfferData(currOffer));
          dispatch(clearOfferValidityData());
          history.push(cartUrl, { offerdetails: currOffer });
        } else {
          // history.push(cartUrl);
          setpriceValidationError(true);
        }
      }
    } else if (
      !offerValidLoading &&
      offerValidSuccess &&
      selectedoffersId == currOffer?.id &&
      isValidOffer &&
      !isMobile
    ) {
      if (totalItemsubTotal >= currOffer?.minOrderAmount) {
        dispatch(setOfferData(currOffer));
        dispatch(clearOfferValidityData());
        // setloginRequestPopup(true);
        // props.onClose(true);
      } else {
        setpriceValidationError(true);
      }
    }
    return () => {
      dispatch(clearOfferValidityData());
    };
  }, [isValidOffer, offerValidSuccess]);

  const setIsOpen = (set: boolean) => {
    if (set) {
      setloginRequestPopup(false);
    }
  };

  const validateOffer = (item: any) => {
    setCurrOffer(item);
    const userId = localStorage.getItem("USER_ID");
    const validityData = {
      customerId: userId ? userId?.toString() : "",
      offerId: item.id,
      couponCode: item.offerCode,
      orderId: "",
      locationId: orderDetails.id,
    };

    validityData && dispatch(requestOfferVality(validityData));
    if (validityData && !isMobile) {
      // props.setofferPopup(true);
    }
  };

  const doAuth = () => {
    dispatch(storeLocationAfterAuth(location.pathname));
    history.push("/signIn");
  };

  const applyOffer = (item: any) => {
    dispatch(clearSelectedOffer());
    if (item.locationId === MAGIL_LOCATION) {
      AppAuth?.userState == "signedIn" || AppAuth?.userState == "guestSignedIn"
        ? validateOffer(item)
        : doAuth();
    } else {
      validateOffer(item);
    }
  };

  const handleSendNoti = (requestOption: string) => {
    const data = {
      orderId: null,
      fullName: null,
      orderNo: null,
      orderTypeId: dineInOrderId,
      status: null,
      orderTime: null,
      isNew: true,
      tableName: tableData.tableName,
      request: requestOption,
    } as NotificationData;
    const notiPayload = {
      messageType: DINE_IN_NOTIFICATION_REQUEST,
      messageData: JSON.stringify(data),
    } as NotificationPayload;
    try {
      sendNotification(restaurantDetails.id, notiPayload);
      setIsMenuOpen(false);
      setCurrentSelectedWaiterOption(requestOption as WaiterOptionType);
    } catch (error) {
      // console.log(error, " ::: error");
    }
  };
  const itemMaxCountPromptVisible = useSelector(
    (state: RootState) => state.cart.itemMaxCountPromptVisible
  );

  //THROTTLING TO BE ADDED
  // const throttledOnSubmit = (requestOption : string)=> throttle(handleSendNoti(requestOption), 3000);

  const handleSelectOption = (requestOption: string) => {
    // setRequestOption(requestOption);
    handleSendNoti(requestOption);
  };

  const handleCallWaiter = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // const [tableDetails, settableDetails] = useState([]);

  useEffect(() => {
    if (
      restaurantDetails &&
      restaurantDetails.id &&
      isContactlessDineInOrder &&
      tableDetails.length == 0
    ) {
      dispatch(getRestaurantTableDetailsRequest(restaurantDetails.id));

      // getRestaurantTableDetails(restaurantDetails.id).then(
      //   (response: AxiosResponse) => {
      //     settableDetails(response.data);
      //   }
      // );
    }
  }, [restaurantDetails.id]);

  const tableData: any = useMemo(() => {
    return (
      (tableDetails &&
        tableDetails.length > 0 &&
        tableDetails.filter((data: any) => data.tableId === tableId)[0]) ||
      []
    );
  }, [tableDetails]);

  const getCurrentActiveWaiterIcon = () => {
    if (currentSelectedWaiterOption == "Call Waiter") {
      return CallWaiterV2Image;
    } else if (currentSelectedWaiterOption == "Ketchup - Request") {
      return KetchupImage;
    } else if (currentSelectedWaiterOption == "Salt & Pepper - Request") {
      return SaltNPepperImage;
    } else if (currentSelectedWaiterOption == "Water - Request") {
      return WaterImage;
    } else if (currentSelectedWaiterOption == "") {
      return CallWaiterImage;
    }
  };

  const toastId = React.useRef<any>(null);

  const closeOfferPicker = (set: boolean) => {
    if (set) {
      setOfferPickerOpen(false);
    }
  };

  const notify = (message: string) => {
    toastId.current = toast.success(message, {
      position: toast.POSITION.TOP_CENTER,
    });
  };

  // useEffect(() => {
  //   const handlePopstate = () => {
  //     setOpenPreviewItemPopupMobile(false);
  //     setOpenCustomisationMobile(false);
  //   };

  //   window.addEventListener("popstate", handlePopstate);

  //   return () => {
  //     window.removeEventListener("popstate", handlePopstate);
  //   };
  // }, []);

    useEffect(() => {
      const unblock = history.block((location:any, action:any) => {   

        //console.log({isCustomerInfoPopupOpen,customizePopup});
        if (isCustomerInfoPopupOpen) {
          setIsCustomerInfoPopupOpen(false)
          return false; 
        }
        if(customizePopup){
          setCustomizePopup(false);
          setCustomizePopupPreview(false);
          return false; 
        }
        return true; 
      });

      return () => {
        unblock();
      };
  }, [history,isCustomerInfoPopupOpen,customizePopup]);

  const cdGuestCount = useSelector((state: RootState) => state.restaurant.cdGuestCount);


  useEffect(() => {
    if (tableId && tableData ) {      
      const count = tableData?.noOfGuests ||0 ;
      count > 0 && dispatch(updateCdGuestCount(count))
      if(isContactlessDineInOrder && count == 0 && cdGuestCount == 0){
        dineInType && history.push(
          getContactlessDineinLandingPage(
            merchantType,
            merchantSlug,
            tableId,
            dineInType?.typeName
          )
        );
        
      }
    }
  }, [tableId,tableData,cdGuestCount,isContactlessDineInOrder]);

  const discountValue = useSelector(
    (state: RootState) => state.order.discountValue
  );

  const isAppliedTip = useSelector((state: RootState) => state.cart.isAppliedTip);

  const tipValue = useSelector((state: RootState) => state.cart.tipValue);
  const tipType = useSelector((state: RootState) => state.cart.tipType);

  useEffect(() => {
    // const isSurchargeApplicable = Boolean(restaurantDetails?.isSurchargeEnabled);
    const itHasPref = Boolean(restaurantDetails?.pref?.[0]?.trim()?.length > 0 );
    const itHasEventOffer = Boolean(restaurantDetails && restaurantDetails?.preOrderLinks?.length > 0);
    // const itHasServiceTax = Boolean((serviceTax && isDineInOrder && restaurantCountry === "US"));
    
    const isCartEmpty = Boolean(cartItems?.length === 0);

    if(!isCartEmpty){
      setIsPopupNotShown(false)
    }

    const shouldShowPopup = Boolean(
        isPopupNotShown &&
        isMobile &&
        restaurantDetails &&(
        (itHasPref ||itHasEventOffer) &&
        (isCartEmpty && !isExistingContactlessDineInOrder) &&
        !eventDate)
    );

    // Update the state
    setIsCustomerInfoPopupOpen(shouldShowPopup);

}, [
    cartItems,
    restaurantDetails,
    isMobile,
    restaurantCountry,
    isPopupNotShown,
    eventDate
    // isExistingContactlessDineInOrder
]);

  const sagaTotalsCallback = () => {
    dispatch(totalsApiLoadingStatusUpadte({ status: false }))
  }

  useEffect(async() => {
    if(cartItems?.length > 0 && restaurantDetails?.id){
      let payload = {    
        discount:selectedOffer ?  selectedOffer?.offerRate : '0',
        discountType:selectedOffer ? selectedOffer?.offerType :'FLATFEE',
        orderItems: cartItems,
        orderTypeId: restaurantOrderTypeId,
        locationId: restaurantDetails.id ,
        tip:tipValue,
        tipType:tipType,
        deliveryFee,
        sagaCallBack: sagaTotalsCallback,
       // walletBalance:RedeemedWalletAmt
      }

      if(isContactlessDineInOrder){
        payload = {...payload,guestCount:cdGuestCount,serviceTaxStatus:0, tableId:tableId}
      }   
      dispatch(totalsApiLoadingStatusUpadte({ status: true }))   
      const data = await manageItemTotalsHelper(payload)

      data && dispatch(
        savePlaceOrderDetails({
          discountValue:  Number(getTotalByCode(data?.orderTotals, '6')) || 0,
          discountType:selectedOffer?.offerType || 'FLATFEE',
          totals:data?.orderTotals,
          orderTotal:data?.orderTotal,
          orderItems:data?.orderItems,
          tip:tipValue,
          tipType:tipType,
          deliveryFee:deliveryFee,
          orderTypeId:restaurantOrderTypeId
        }),
      );
    }
  }, [cartItems,restaurantDetails.id,discountValue,tipValue,selectedOffer,deliveryFee,cdGuestCount])
    
  if(isMobile && (restaurantMenuDetailLoading || restaurantDetailLoading)){
    return <Loading type="pageLoad" />
  }


  return (
    <div
      style={!isMobile ? { flex: 1, display: "flex" } : {}}
      className={isMobile ? "menu-list-mobile-container" : ""}
    >
      <PWAInstaller />
      {!isMobile &&
      (!restaurantMenuDetailLoading || restaurantMenuDetails)&&
      (!restaurantDetailLoading|| restaurantDetails) &&
      !isContactlessDineInOrder ? (
        <div style={{ display: "flex", width: "30%" }}>
          <DesktopCategoryFilter
            categories={categories}
            currentCategory={currentCategory}
            setCurrentCategory={setCurrentCategory}
            showCategory={showCategory}
            specialMenuCategory={getSpecialMenuText}
            getPreviouslyOrderedMenuText={getPreviouslyOrderedMenuText}
            currentRestaurantDishViewType={currentRestaurantDishViewType}
            setCurrentRestaurantDishViewType={setCurrentRestaurantDishViewType}
          />
        </div>
      ) : null}
      <ConfirmationPrompt
        question={"You don't have orders"}
        isOpen={showNoItemsModal}
        submitPrompt={() => {
          setShowNoItemsModal(!showNoItemsModal);
          dispatch(setMenuOption("Menu"));
        }}
        InfoImage={null}
        type={"alert"}
        submitText="Ok"
      />
      <ConfirmationPrompt
        question={"Please Contact Restaurant for Bulk Orders"}
        isOpen={itemMaxCountPromptVisible}
        submitPrompt={(answer: boolean) => dispatch(hideItemMaxCountPrompt())}
        submitText={"ok"}
        cancelText={"Cancel"}
        InfoImage={null}
        type="prompt"
      />
      <SpecialNotePrompt
        isOpen={showSpeicalNotePromptID == "" ? false : true}
        itemId={showSpeicalNotePromptID}
        submitPrompt={submitSpecialNote}
        text={"Add Special Note"}
        type="Special Note"
      />

{isCustomerInfoPopupOpen &&<CustomerInfoPopup isOpen={isCustomerInfoPopupOpen} onClose={()=>{setIsPopupNotShown(false);setIsCustomerInfoPopupOpen(false);}} />}
      {/* <CustomisationPrompt
        isOpen={openCustomisation}
        onClose={() => {
          setCustomisationItemId("");
          setOpenCustomisation(false);
        }}
        itemId={customisationItemId}
        setOpenCustomisation={setOpenCustomisation}
      /> */}
      <PreviewItemPrompt
        isOpen={openPreviewItemPopup}
        onClose={() => {
          setCustomisationItemId("");
          setOpenPreviewItemPopup(false);
        }}
        itemId={customisationItemId}
        setOpenCustomisation={setOpenCustomisation}
      />

      {openPreviewItemPopupMobile && (
        <CustomizeCartPrevMobile
          isOpen={openPreviewItemPopupMobile}
          onClose={() => {
            setCustomisationItemId("");
            setOpenPreviewItemPopupMobile(false);
            window.history.back();
          }}
          itemId={customisationItemId}
          setOpenCustomisation={setOpenPreviewItemPopupMobile}
          isPreview={true}
        />
      )}

      {openCustomisationMobile && (
        <CustomizeCartMobile
          isOpen={openCustomisationMobile}
          onClose={() => {
            setCustomisationItemId("");
            setOpenCustomisationMobile(false);
            window.history.back();
          }}
          itemId={customisationItemId}
          setOpenCustomisation={setOpenCustomisationMobile}
          isPreview={true}
          // menuType={
          //   isMobile || isContactlessDineInOrder ? menuType : props.menuType
          // }
          // restaurantSlug={merchantSlug}
          // tableId={''}
        />
      )}


        {customizePopup && (
            <CustomizeCart
              isOpen={customizePopup}
              onClose={(isMobileCart:boolean) => {
                setCustomisationItemId("");
                setCustomizePopup(false);
                setCustomizePopupPreview(false);
                //isMobileCart && window.history.back();
              }}
              custimizeItemId={customisationItemId}
              setOpenCustomisation={()=>{setCustomizePopup(false);setCustomizePopupPreview(false);}}
              isPreview={customizePopupPreview}
              isMobile={isMobile}
              tableId={tableId}
              menuType={isMobile || isContactlessDineInOrder ? menuType : props.menuType}
              cutOffTimeExceeds={cutOffTimeExceeds(isMobile || isContactlessDineInOrder ? menuType : props.menuType)}
            />
          )}


      {isFiltering ? (
        <RestaurantHomeFilter
          setIsFiltering={setIsFiltering}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
      ) : null}
      {currentRestaurantMenuType === "DineIn" &&
        checkInFloatingBar &&
        restaurantDetails.dining === 0 &&
        isCheckInwithData !== "true" &&
        currentReservation && (
          <CheckInFloatingCart
            checkInFloatingBar={checkInFloatingBar}
            setcheckInFloatingBar={setcheckInFloatingBar}
          />
        )}
      {/* <OrderConfirmationModal
        isVisible={isMenuOptionSelected("Cart")}
        handleCallback={(option: MenuOptionType) => {
          setCurrentSelectedMenuOption(option);
          if (option == "Order") {
            history.push({
              pathname: getPlaceOrderURL(
                cartMerchantType,
                cartRestaurantSlug,
                cartMenuType
              ),
              state: { query: "tableSide" },
            });
          }
        }}
      /> */}

      {/* //list container */}
      <div
        id="merchant-home-page-container"
        style={
          cartItems.length > 0
            ? {
                // marginBottom: "7%",
                width: isMobile || isContactlessDineInOrder ? "100%" : "70%",
              }
            : { width: isMobile || isContactlessDineInOrder ? "100%" : "70%" }
        }
        className={
          isFiltering || isMenuOpen ? "menu-dim menu-list" : "menu-list"
        }
      >
        {isMobile && (
          <div id="merchant-home-page-options-container">
            <div id="merchant-home-page-options">
              <div>
                {!isContactlessDineInOrder && !eventDate &&  (
                  <LeftArrow
                    style={{
                      display: isContactlessDineInOrder ? "none" : "",
                      height: "1rem",
                      paddingRight: "0.7rem",
                      cursor: "pointer",
                    }}
                    onClick={() => {                      
                      if (
                        location &&
                        location.state &&
                        location.state.query === "tableSide"
                      ) {
                        dispatch(clearRestaurantDetailsByLocationId());
                       // history.goBack();
                        history.push(location.state.prePath)
                      } else if(location?.search === "?tableSide"){
                        //dispatch(clearRestaurantDetailsByLocationId());
                        //history.goBack();
                         //history.push(location.state.prePath)
                         window.close()
                      }else {
                        history.push(
                          getMerchantHomeURL(merchantType, merchantSlug)
                        );
                      }
                    }}
                  />
                )}
                <span
                  style={{
                    color: "black",
                    fontSize: "0.9rem",
                    fontWeight: 500,
                    fontFamily: "Poppins",
                    // paddingLeft: "0.7rem",
                  }}
                  // onClick={() => {
                  //   // history.goBack();
                  //   !isContactlessDineInOrder && !eventDate && !isPickupOrder && !isDeliveryOrder  &&
                  //     history.push(
                  //       getMerchantHomeURL(merchantType, merchantSlug)
                  //     );
                  // }}
                >
                  {restaurantDetails.branchName}
                </span>
              </div>
            </div>

           {/* {serviceTax && isDineInOrder && restaurantCountry == "US" && (
              <span className="gratuity-message">
                {serviceTax?.rate}% Gratuity is applicable for 5 or more guests.
              </span>
            )} 
             {restaurantDetails && restaurantDetails.pref && (
              <span className="gratuity-message">
                {restaurantDetails.pref.map((item, index) => (
                  <div key={index}>{item}</div>
                ))}
              </span>
            )} */}
            {restaurantDetails.open === 0 && (
              <div className="resClosingTimeContainer">
                {/* <p className="resClosingTimeText">
                  Not accepting orders at this time!
                </p> */}
              </div>
            )}
          </div>
        )}
        {(isMobile || isContactlessDineInOrder) && (
          <>
            {isSearching ? (
              <div id="merchant-home-page-search">
                <input
                  type="text"
                  ref={searchRef}
                  autoFocus={true}
                  placeholder={"Search"}
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                />
                <CrissCross
                  onClick={() => {
                    setSearchText("");
                    setIsSearching(false);
                    isContactlessDineInOrder && dispatch(setMenuOption("Menu"));
                  }}
                />
              </div>
            ) : (
              <div className="homeMenuOptions">
                <span className="menuTypeSelector">
                  {/* {!isMenuAdd(menuType) &&
                restaurantMenuTypes &&
                restaurantMenuTypes?.length > 0 && (
                  <DropDown
                    value={selectedMenuType}
                    type={"section"}
                    setValue={setSelectedMenuType}
                    onChange={(menuType: string) => {
                      setSelectedMenuType(menuType);
                      dispatch(
                        getRestaurantMenuDetails({
                          type: menuType,
                          locationId: restaurantDetails.id,
                          customerId: UserId,
                          searchText:
                            location.state.keyword &&
                            location.state.keyword != null
                              ? location.state.keyword
                              : null,
                        })
                      );
                      history.push(getMerchantMenuURL(merchantSlug, menuType));
                    }}
                    defaultValue={menuType}
                    labelName={"menuType"}
                    dropDownOptions={restaurantMenuTypes || []}
                  />
                )} */}
                  {isMenuAdd(menuType) || restaurantMenuTypes?.length == 0 ? (
                    <span className="tableName-container">
                      <span
                        className="menuTypeValue"
                        style={{
                          marginBottom: isContactlessDineInOrder
                            ? "0.5rem"
                            : "0rem",
                        }}
                      >
                        {menuType ? menuType : null} {" Menu"}{" "}
                      </span>
                      {isContactlessDineInOrder && (
                        <span className="menuTypeValue">
                          {"Table "}
                          {tableData.tableName}
                        </span>
                      )}
                    </span>
                  ) : null}
                </span>
                

                {dishes.length > 0 && !isContactlessDineInOrder ? (
                  <div id="merchant-home-page-options-buttons">
                    {/* <FilterIcon
                  onClick={() => {
                    setIsFiltering(true);
                    setSelectedDish("");
                  }}
                /> */}
                    {dishes.length > 0 && !isContactlessDineInOrder ? (
                      <SearchIcon
                        style={{ float: "right" }}
                        onClick={() => {
                          setIsSearching(true);
                          // setCurrentSubcategory("");
                        }}
                      />
                    ) : null}
                  </div>
                ) : null}
              </div>
            )}
            
          </>
          
        )}
        






        {!isSearching && isContactlessDineInOrder ? (
          <Fragment>
            {/* <div id="menu-options-container">
              {merchantType == "restaurant" &&
                restaurantDishViewTypes.map((dishViewType: string) => {
                  return (
                    <span
                      key={dishViewType}
                      className={
                        currentRestaurantDishViewType == dishViewType
                          ? "menu-button-design"
                          : "inactive-button-design"
                      }
                      onClick={() =>
                        setCurrentRestaurantDishViewType(dishViewType)
                      }
                    >
                      {dishViewType}
                    </span>
                  );
                })}
            </div> */}

            <span
              style={{
                width: "100%",
                borderTop: "1px solid rgba(196, 196, 196, 0.2)",
              }}
            ></span>

            {/* SubCategory Filtering */}
            {/* {currentRestaurantDishViewType == "Menu" ? (
              <DishFilterScrollView
                scrollOptions={subCategories}
                setShowMenu={setShowMenu}
                currentSubcategory={currentSubcategory}
                setCurrentSubcategory={setCurrentSubcategory}
                setCurrentType={setCurrentType}
                getMenuItemImageUrl={getMenuItemImageUrl}
              />
            ) : null} */}
          </Fragment>
        ) : null}





        <div
          className={
            isMobile
              ? "menu-details-container-mobile"
              : "menu-details-container"
          }
        >
          {!restaurantDetailLoading &&
            !restaurantMenuDetailLoading &&
            !isSearching &&
            (isMobile || isContactlessDineInOrder) && (
              // !isSpecialMenuView() &&
              <div className="menu-header-container">
                <MenuHeader
                  categories={categories}
                  currentCategory={currentCategory}
                  setCurrentCategory={setCurrentCategory}
                  showCategory={showCategory}
                  specialMenuNames={specialMenuNames}
                  isSpecialMenuAvailable={isSpecialMenuAvailable}
                  previouslyOrderedMenuName={previouslyOrderedMenuName}
                  isPreviouslyOrderedMenuAvailable={
                    isPreviouslyOrderedMenuAvailable
                  }
                  setCurrentRestaurantDishViewTypeExclusive={setCurrentRestaurantDishViewTypeExclusive}
                  setCurrentRestaurantDishViewType={
                    setCurrentRestaurantDishViewType
                  }
                />
              </div>
            )}
          {(isMobile || isContactlessDineInOrder) &&
          !restaurantDetailLoading &&
          !restaurantMenuDetailLoading &&
          restaurantMenuDetails &&
          restaurantMenuDetails.length > 0 &&
          isSearching &&
          dishes &&
          dishes.length == 0 ? (
            <div className="search-not-found">
              <span>Sorry We couldn't find any matches for</span>
              <span>{searchText ? searchText : ""}</span>
              <div className="snf-list">
                <span>
                  <span className="snf-bullet"></span> Make sure the spelling is
                  correct
                </span>
                <span>
                  <span className="snf-bullet"></span>Use less keywords
                </span>
                <span>
                  <span className="snf-bullet"></span>Try removing search
                </span>
              </div>
            </div>
          ) : null}

          {(((restaurantDetailLoading) ||
          restaurantMenuDetailLoading )) ? (
            <>
              {[...Array(5)].map((e, i) => (
                <div className="skeleton-container" key={i}>
                  <div className="skeleton-namePrice-container">
                    <div className="skeleton-name">
                      <Skeleton height={20} />
                      <Skeleton height={20} width={100} />
                    </div>
                    {/* <div className="skeleton-price">
                      <Skeleton height={20} />
                    </div> */}
                  </div>
                  {/* <div className="skeleton-ingr-contianer">
                    <Skeleton height={40} width={30} />
                    <Skeleton height={40} width={30} />
                    <Skeleton height={40} width={30} />
                  </div> */}
                  {/* <Skeleton height={20}  width={70}/> */}
                  {/* <div className="skeleton-button-container">
                    <Skeleton height={20} width={55} borderRadius={15} />
                  </div> */}
                </div>
              ))}
            </>
          ) : (
            // </div>
            // </div>
            // <div
            //   style={{
            //     width: "100%",
            //     display: "flex",
            //     flexDirection: "column",
            //     alignItems: "center",
            //     justifyContent: "center",
            //     marginTop: "30%",
            //   }}
            // >
            //   {merchantType == "restaurant" ? <CookingImage /> : <SalonImage />}
            //   <span style={{ marginTop: "3rem" }}>
            //     Please wait while we load your choices
            //   </span>
            // </div>
            <Fragment>
              {/* {cartMenuType !== "Menu" && (
                <div className="offerName-container">
                  <div style={{ display: "flex" }}>
                    {!isMobile &&
                      availableCoupon.map((item) => {
                        return (
                          <div
                            className="offerName"
                            onClick={() => {
                              navigator.clipboard.writeText(item.offerCode);
                              notify("Coupon code copied successfully");
                              // setOfferPickerOpen(true)
                            }}
                          >
                            Use Coupon: {item.offerCode}
                          </div>
                        );
                      })}
                  </div>
                </div>
              )} */}
              {/* {availableCoupon.length > 2 && !isMobile && (
                <p
                  className="view-all-offer"
                  onClick={() => {
                    setOfferPickerOpen(true);
                  }}
                >
                  See all offers
                </p>
              )} */}
             {/* <div>
              {(isMobile || isContactlessDineInOrder) && (
        <div className="specialMenu-component">
              <SpecialMenu openOrNot={restaurantDetails.open}
              menuType={menuType}
              orderTypeEnabled={isorderTypeEnabled}
              menuView={isMenuView(menuType)}
              
              setCustomisationItemId={setCustomisationItemId}
            

              />
            </div>
             )}
              </div> */}
              {
                !isSearching && currentRestaurantDishViewTypeExclusive ==="Exclusive"&&currentRestaurantDishViewType !== "Special Menu" && currentRestaurantDishViewType !== "Previously Ordered" &&
                <div className="special-menu-items-container" >
              {dishes?.filter((menuDetail: RestaurantMenuItem) => menuDetail.isExclusiveCategoryItem).length > 0 && (
   <h1 className="todays-exclusive-heading">Today's Exclusive</h1>
)}
               
                <div className="special-menu-items">
                {specialDishes
                        ?.filter((menuDetail: RestaurantMenuItem) => {
                          return (
                            menuDetail.isExclusiveCategoryItem && menuDetail.display===1 && menuDetail.enable && (!((menuDetail.stockQuantity !== null &&
                              Number(menuDetail.stockQuantity) < 1) ||  menuDetail.isCategoryOff == true ))
                           
                          );
                        })
                        
                        .map((menuDetail: RestaurantMenuItem, index) => {
                          return (
                            <SpeciaMenucard
                              menuDetail={menuDetail}
                              key={menuDetail.itemId}
                              ItemUpdate={ItemUpdate}
                            />
                          );
                        })}
                </div>
             
              </div>
              }
              
              
              <div className="sub-category-container">
                {previouslyOrderedMenuName.length > 0 &&
                  !isMobile &&
                  (currentRestaurantDishViewType === "Recommendation" ||
                    currentRestaurantDishViewType === "Previously Ordered" ||
                    currentRestaurantDishViewType === "Special Menu") && (
                    <span className="category-field Prev-Order-txt">
                      <div
                        className={
                          currentCategory == "" &&
                          currentRestaurantDishViewType === "Previously Ordered"
                            ? "merchant-category-value category-value-selected"
                            : "merchant-category-value"
                        }
                        onClick={() => {
                          setCurrentRestaurantDishViewType(
                            "Previously Ordered"
                          );
                          if (currentCategory == "") {
                            setCurrentCategory("");
                          } else {
                            showCategory("");
                            setCurrentCategory("");
                          }
                          // setShowCategories(false);
                        }}
                      >
                        <span>Previously Ordered</span>
                        {/* <span>{props.categories.quantity}</span> */}
                      </div>
                    </span>
                  )}
                {!isMobile &&
                  (currentRestaurantDishViewType === "Recommendation" ||
                    currentRestaurantDishViewType === "Previously Ordered" ||
                    currentRestaurantDishViewType === "Special Menu") &&
                  getSpecialMenuText &&
                  getSpecialMenuText().length > 0 && (
                    <span className="Prev-Order-txt">
                      <div
                        className={
                          currentCategory == ""
                            ? "category-field"
                            : "category-field"
                        }
                      >
                        {getSpecialMenuText &&
                          getSpecialMenuText().map((name: string, i: any) => {
                            return (
                              <div
                              key={i}
                                className={
                                  currentRestaurantDishViewType !==
                                    "All Items" &&
                                  currentRestaurantDishViewType !==
                                    "Recommendation" &&
                                  currentRestaurantDishViewType !==
                                    "Previously Ordered"
                                    ? "merchant-category-value category-value-selected"
                                    : "merchant-category-value"
                                }
                                key={i}
                                onClick={() => {
                                  setCurrentRestaurantDishViewType(name);
                                  showCategory("");
                                  setCurrentCategory("");
                                }}
                              >
                                <span>{name}</span>
                              </div>
                            );
                          })}
                      </div>
                    </span>
                  )}
              </div>
              {searchText.length > 0 && isSearching ? (
                <div className="dishCardsContainer">
                  {dishes
                    .filter(menuItemDisplayFilter)
                    .map((menuDetail: RestaurantMenuItem, index) => {
                      return (
                        <RenderDishCard
                          menuDetail={menuDetail}
                          key={menuDetail.itemId}
                          ItemUpdate={ItemUpdate}
                        />
                      );
                    })}
                </div>
              ) : null}

              {!restaurantDetailLoading &&
                !restaurantMenuDetailLoading &&
                restaurantMenu?.length == 0 && (
                  <span className="noItemText">No Item Found</span>
                )}

              {/* Calling Menu List */}

              {MenuTypeView()}

              <div className="emptyDiv" />
            </Fragment>
          )}
        </div>
      </div>

      {/* //Waiter Menu Float Icon */}

      <CallWaiter
        isMenuOpen={isMenuOpen}
        dineInOrderId={dineInOrderId}
        tableData={tableData}
        restaurantDetails={restaurantDetails}
        setIsMenuOpen={setIsMenuOpen}
        isContactlessDineInOrder={isContactlessDineInOrder}
      />
      {/* //bottom container */}

      <div
        style={{
          flex: 1,
          bottom: 0,
          position: "absolute",
        }}
      >
        {isContactlessDineInOrder ? (
          <BottomNavigation
            handleCallBack={(option: MenuOptionType) => {
              if (option == "Search") {
                // console.log("Search is Updating from Handle Callback ::::");

                setIsSearching(true);
                setIsMenuOpen(false);
              } else if (option == "Cart") {
                if (orderId) {
                  history.push({
                    pathname: getDineInOrderedPlaceOrderURL(
                      merchantSlug,
                      menuType,
                      tableId,
                      orderId
                    ),
                    state: { query: "tableSide" },
                  });
                } else {
                  history.push({
                    pathname: getDineInPlaceOrderURL(
                      merchantSlug,
                      menuType,
                      tableId
                    ),
                    state: { query: "tableSide" },
                  });
                }
              } else if (option == "Order") {
                //console.log({ orderDetail });

                if (orderDetail && orderDetail.orderId) {
                  history.replace(
                    getContactlessDineInOrderStatusURL(
                      merchantType,
                      merchantSlug,
                      tableId,
                      orderDetail ? orderDetail.orderId : "-"
                    )
                  );
                } else {
                  setShowNoItemsModal(true);
                }
              } else if (option == "Menu") {
                setIsSearching(false);
                setSearchText("");
              }
            }}
          />
        ) : null}
      </div>
      <LoginRequestPrompt
        isOpen={loginRequestPopup}
        visible={setIsOpen}
        title={" Login to avail offer"}
        subtext={" You need to login to apply this promocode."}
        cartUrl={isContactlessDineInOrder ? location.pathname : cartUrl}
      />
      <OfferPrompt
        isOpen={offerPickerOpen}
        onClose={closeOfferPicker}
        isCopied={true}
      />
    </div>
  );
}

export default RestaurantHome;
